var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"hx-trip desc"},[_c('el-row',[_c('p',[_vm._v("好行网")])]),_c('el-row',[_c('img',{attrs:{"src":require("@/assets/images/projects/trip/trip.jpg"),"alt":""}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }